import { styled } from "@mui/material";

export const ContainerSyled = styled("div")(({ colorStyles }) => ({
  width: "100%",
  margin: 0,
  padding: "8px",
  display: "flex",
  gap: "8px",
  border: `1px solid ${colorStyles.border}`,
  borderRadius: "8px",
  backgroundColor: colorStyles.background,
}));
